document.addEventListener("turbo:load", () => {
  const select = document.getElementById("original_fundraiser");
  if (!select) return;

  console.log("Load: fundraisers/copy_previous.js")

  select.addEventListener("change", (e) => {
    const id = e.target.value;
    if (!id) return;

    const targetId = `fundraiser${id}`;
    const target = document.getElementById(targetId);
    if (!target) return;

    // Hide all explanations
    document.querySelectorAll(".explanation").forEach(el => {
      el.style.display = "none";
    });

    // Show selected explanation
    target.style.display = "block";
  });
});